import {IFileIdAndOwner, IFileToPathConverter} from '../../interfaces/ifiletopathconverter';

export class BullhornFileToPathConverter implements IFileToPathConverter {
  private readonly listType: string;

  constructor(listType: string) {
    this.listType = listType;
  }

  convert(file: IFileIdAndOwner): string[] {
    return [
      file.belongsTo?.type, // Candidate
      file.belongsTo?.id, // Candidate id
      file.id, // file id
    ];
  }
}
